import { createRoutine } from "redux-saga-routines";

export const getAllEvents$ = createRoutine("GET_ALL_EVENTS");

export const getEventBookings$ = createRoutine("GET_EVENT_BOOKINGS");

export const getEventAttendees$ = createRoutine("GET_EVENT_ATTENDEES");

export const getAllwebinars$ = createRoutine("GET_ALL_WEBINARS");





// WEBPACK FOOTER //
// ./src/redux/actions/event.js